// CIMA brand constants - single source of truth
export const CIMA = {
  name: "CIMA",
  fullName: "Comercializadora Industrial Médica",
  phone: "755 554 7990",
  phoneTel: "+527555547990",
  whatsapp: "755 102 5813",
  whatsappIntl: "5217551025813",
  email: "infrazih@gmail.com",
  address: "Paseo de Zihuatanejo Oriente #198, Col. El Hujal, Zihuatanejo de Azueta, Gro. C.P. 40880",
  hours: "Lun – Vie hasta las 5:30 p.m. · Sáb hasta las 2:00 p.m.",
  hoursFull: "Lun – Vie · 8:00 a.m. – 5:30 p.m.  ·  Sáb · 8:00 a.m. – 2:00 p.m.",
  hoursWeek: "Lun – Vie · 8:00 a.m. – 5:30 p.m.",
  hoursSat: "Sáb · 8:00 a.m. – 2:00 p.m.",
  emergency24Tel: "+527555547990",
  emergency24Whatsapp: "5217551025813",
  emergency24Label: "Atención 24/7 · Oxígeno medicinal",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_cima-industrial/artifacts/cgo7zgyl_image.png",
  mapsEmbed:
    "https://www.google.com/maps?q=17.6501506,-101.5367568&z=17&output=embed",
  mapsLink:
    "https://maps.app.goo.gl/5tFYyh44YzFqQQJs9",
  facebookUrl:
    "https://www.facebook.com/profile.php?id=61575370384059",
};

export const buildWhatsappLink = (msg) =>
  `https://wa.me/${CIMA.whatsappIntl}?text=${encodeURIComponent(
    msg || "Hola CIMA, me gustaría solicitar información / cotización."
  )}`;

// Opens WhatsApp in a real new top-level tab. This bypasses iframe
// restrictions (e.g. ERR_BLOCKED_BY_RESPONSE in preview environments)
// where a plain <a target="_blank"> may try to navigate within the iframe.
export const openWhatsapp = (msg) => {
  const url = buildWhatsappLink(msg);
  try {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (!win) {
      // Popup blocked – fall back to top-level navigation
      window.location.href = url;
    }
  } catch (_e) {
    window.location.href = url;
  }
};
